var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4429 23.1788L25.7078 5.45285L24.519 4.26408C24.2481 3.99501 23.8818 3.84399 23.5 3.84399C23.1182 3.84399 22.752 3.99501 22.4811 4.26408L3.55717 23.1788C3.27963 23.4553 3.06028 23.7845 2.91208 24.1472C2.76388 24.5098 2.68982 24.8984 2.69428 25.2901C2.71264 26.9058 4.05747 28.1955 5.67309 28.1955H7.62377V43.1446H39.3763V28.1955H41.3683C42.1532 28.1955 42.8921 27.888 43.4475 27.3326C43.721 27.06 43.9376 26.7359 44.085 26.379C44.2323 26.0221 44.3073 25.6395 44.3058 25.2534C44.3058 24.4732 43.9983 23.7342 43.4429 23.1788ZM26.0703 39.84H20.9297V30.4767H26.0703V39.84ZM36.0716 24.8908V39.84H29.0078V29.3751C29.0078 28.3608 28.1863 27.5392 27.1719 27.5392H19.8282C18.8138 27.5392 17.9922 28.3608 17.9922 29.3751V39.84H10.9285V24.8908H6.52221L23.5046 7.92218L24.5649 8.98244L40.4825 24.8908H36.0716Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.43232e15fb32485b2d63bf89ef3f7b1c.svg";
export { ForwardRef as ReactComponent };